export const basketsKeys = {
  all: ['baskets'] as const,
  lists: () => [...basketsKeys.all, 'list'] as const,
  list: (params: Record<string, any> = {}) =>
    [...basketsKeys.lists(), params] as const,
  summaries: () => [...basketsKeys.all, 'summary'] as const,
  summary: (campaignId: string | number) =>
    [...basketsKeys.summaries(), campaignId] as const,
  proposals: (id: number) => [...basketsKeys.detail(id), 'proposals'] as const,
  orders: (id: number) => [...basketsKeys.detail(id), 'orders'] as const,
  committed: (id: number) => [...basketsKeys.detail(id), 'committed'] as const,
  committedOrders: (id: number) =>
    [...basketsKeys.detail(id), 'committed', 'orders'] as const,
  committedProposals: (id: number) =>
    [...basketsKeys.detail(id), 'committed', 'proposals'] as const,

  details: () => [...basketsKeys.all, 'detail'] as const,
  detail: (id: number) => [...basketsKeys.details(), id] as const,
};
